
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evm/new-safe/load",
      function () {
        return require("private-next-pages/evm/new-safe/load.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evm/new-safe/load"])
      });
    }
  